module.exports = __webpack_public_path__ + "static/media/aa.f34a6d04.mp4";